<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="green"
          :loading="loading"
        >
          <v-form
            ref="account"
          >
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    class="purple-input"
                    label="Unidade"
                    disabled
                    :value="current_unity.name"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="model.username"
                    label="Login"
                    :rules="rules.login"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="model.name"
                    label="Nome Completo"
                    :rules="rules.name"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="model.email"
                    label="Email"
                    class="purple-input"
                    :rules="rules.email"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-select
                    v-model="model.auth_method_id"
                    label="Método de Autenticação"
                    :items="auth_methods"
                    :loading="loading"
                    item-text="name"
                    item-value="id"
                    single-line
                    :rules="rules.auth_method"
                    :hint="'Selecione \'Autenticação Via Siga\' para utilizar o login e senha desta plataforma. O login deve ser o seu CPF'"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-if="passwordEnabled"
                    v-model="model.password"
                    type="password"
                    label="Senha"
                    class="purple-input"
                    :rules="rules.password"
                    :counter="true"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-checkbox
                    v-model="model.is_admin"
                    label="Usuário Administrador?"
                    required
                    @keyup.enter="handleSubmit"
                  />
                </v-col>

                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    :loading="loading"
                    color="success"
                    @click="handleSubmit()"
                  >
                    {{ action == 'POST' ? 'CRIAR' : 'EDITAR' }} Conta
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import {
        mapState,
    } from 'vuex'

    export default {
        data() {
            return {
                rules: {
                    login: [(v) => !!v || 'Campo Obrigatório'],
                    name: [(v) => !!v || 'Campo Obrigatório'],
                    email: [(v) => !!v || 'Campo Obrigatório', (v) => /.+@.+\..+/.test(v) || 'E-mail deve ser válido'],
                    auth_method: [(v) => !!v || 'Campo Obrigatório', (v) => this.togglePassword(v === 1)],
                    password: [(v) => (v ? v.length >= 8 : this.action === 'PATCH') || 'A senha deve ter no mínimo 8 caracteres'],
                },
                action: 'POST',
                passwordEnabled: true,
                edit: {}
            }
        },
        computed: {
            ...mapState('account', ['user', 'current_unity', 'auth_methods']),
            ...mapState('app', ['loading']),
            model() {
                return {
                    name: this.edit.name,
                    username: this.edit.username,
                    email: this.edit.email,
                    auth_method_id: this.edit.auth_method ? this.edit.auth_method.id : this.auth_methods[0].id,
                    password: this.edit.password,
                    is_admin: this.edit.is_admin || false,
                    unity_id: this.current_unity.id,
                }
            },
        },
        mounted() {
            if (this.$route.params.id) {
                this.get()
            } else {
                this.$refs.account.resetValidation()
            }
        },
        methods: {
            handleSubmit() {
                if (this.$refs.account.validate())
                    return this.post()

            },
            togglePassword(toggle) {
                this.passwordEnabled = toggle
                return true
            },
            get() {
                this.$store.dispatch('account/GET', {
                    id: this.$route.params.id,
                    unity_id: this.current_unity.id,
                }).then((response) => {
                    this.edit = response
                }).catch(() => {

                })
                this.action = 'PATCH'
            },
            post() {
                const vm = this
                this.$store.dispatch(`account/${this.action}`, {
                    id: this.$route.params.id,
                    model: this.model,
                }).then(() => {
                    this.$store.commit('app/SHOW_NOTIFICATION', {body: `${this.model.name} ${this.action == 'POST' ? 'criado' : 'editado' } com sucesso`, color: 'green'}, {root: true})
                    vm.$router.push('/accounts')
                }).catch((e) => {
                    console.log(e)
                })
            },
        },
    }
</script>
